// src/components/UserDropdown.js

import React, { useState } from "react";

const UserDropdown = ({ user, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Function to get the correct profile image URL
  const getProfileImageUrl = (user) => {
    // Debugging: Log the user object to see what it contains
    // console.log('User object for avatar:', user);

    if (user && user.imageUrl) {
      // Add check for user existence
      return user.imageUrl; // Google SSO typically provides imageUrl
    } else if (user && user.picture) {
      // Add check for user existence
      return user.picture; // Fallback to picture if imageUrl is not available
    }
    // Use a root-relative path for the default avatar in the public folder
    return "/default-avatar.png";
  };

  // Add a check in case user object is initially null or undefined
  if (!user) {
    return null; // Or return a placeholder/loading state
  }

  return (
    <div className="relative inline-block text-left">
      {/* Avatar */}
      <div
        onClick={toggleDropdown}
        className="user-icon cursor-pointer flex items-center"
      >
        <img
          src={getProfileImageUrl(user)}
          alt="User avatar"
          className="w-12 h-12 avatar rounded-full border"
          // Optional: Add an onError handler to catch loading errors
          onError={(e) => {
            console.error("Error loading image:", e.target.src);
            // Optionally set to default avatar if the primary URL fails
            // e.target.src = '/default-avatar.png';
          }}
        />
      </div>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="user-dropdown absolute right-0 focus:outline-none">
          <div className="" role="menu">
            <div className="user-info">
              {/* Display user's name if available */}
              <p className="user-dropdown-name block ">{user.name || "User"}</p>
              <p className="user-dropdown-mail block ">{user.email}</p>
            </div>
            <button
              className="user-logout block w-full"
              role="menuitem"
              onClick={onLogout}
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
